import { UserGeneralKey } from '@/models/user.generalkey';
export function debugLogin() {
    const debugLogin = sessionStorage.getItem('DEBUG_LOGIN');
    const debugGetUserDataBefore = sessionStorage.getItem('DEBUG_GETUSERDATA_BEFORE');
    const debugGetUserDataAfter = sessionStorage.getItem('DEBUG_GETUSERDATA_AFTER');
    const debugGuard = sessionStorage.getItem('DEBUG_GUARD');
    const currentRole = localStorage.getItem('USER_ROLE');
    if (debugGetUserDataBefore) {
        const data = JSON.parse(debugGetUserDataBefore);
    }
    if (debugGetUserDataAfter) {
        const data = JSON.parse(debugGetUserDataAfter);
    }
    if (debugLogin) {
        const data = JSON.parse(debugLogin);
    }
    if (debugGuard) {
        const data = JSON.parse(debugGuard);
    }
    return {
        currentRole,
        debugLogin: debugLogin ? JSON.parse(debugLogin) : null,
        debugGetUserDataBefore: debugGetUserDataBefore ? JSON.parse(debugGetUserDataBefore) : null,
        debugGetUserDataAfter: debugGetUserDataAfter ? JSON.parse(debugGetUserDataAfter) : null,
        debugGuard: debugGuard ? JSON.parse(debugGuard) : null
    };
}
if (typeof window !== 'undefined') {
    window.debugLogin = debugLogin;
    window.testRole = () => {
        const role = localStorage.getItem('USER_ROLE');
        const isFranchise = UserGeneralKey.isFranchise(role);
        const route = UserGeneralKey.getDashboardRoute(role);
        return {
            role,
            isFranchise,
            route
        };
    };
}
